
import { BrowserRouter } from "react-router-dom";
import RoutesApp from "./routes";
import Analytics from "./routes/Analytics";

function App() {
  return (
    <BrowserRouter>
        <Analytics></Analytics>
        <RoutesApp></RoutesApp>
    </BrowserRouter>
  );
}

export default App;